{
  "uigAddToCart": {
    "addingProductToCart": "Artikel #{{productCode}} wurde in den Warenkorb gelegt",
    "backendMessage": "Art.Nr.: {{productCode}} - {{errDescription}}",
    "itemsNotListedForUser": "Das Produkt ist für Sie nicht gelistet.",
    "noStock": "Die Menge in Ihrem Warenkorb haben wir leider nicht auf Lager.",
    "removedItem": "Das Produkt wurde erfolgreich aus dem Warenkorb gelöscht."
  }
}
